<template>
    <b-card no-body class="text-center">
        <b-card-body>

            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <lg-form-const-select @change="load()" class="text-left" label="Situação:" cols="8" sm="4" md="2"
                        v-model="form.situacao" :options="form.optionsFilterSituacao" />
                    <lg-form-input class="text-left" v-model="form.nome" label="Nome:" cols="8" sm="4" md="6" />
                    <b-button id="localizarPessoa" class="mx-1 my-3" size="sm" style="height: 20px" pill
                        variant="primary" @click="load()">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="search" /> &nbsp;
                        </div>

                        <b-tooltip target="localizarPessoa" title="Localizar"></b-tooltip>
                    </b-button>
                    <b-button id="novaPessoa" class=" mt-3" style="height: 20px" @click="abrirCadastrarPessoaModal"
                        size="sm" pill variant="primary">
                        <div class="btn-size-alinhamento">
                            <b-icon scale="1" icon="plus" />&nbsp;

                        </div>
                        <b-tooltip target="novaPessoa" title="Adicionar novo..."></b-tooltip>

                    </b-button>
                </b-form-row>
                <b-table responsive class="mt-2" :busy="this.busy" :items="this.records" :fields="this.tableFields"
                    :hover="true" @row-dblclicked="pessoaSelect" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>


                    <template #empty>
                        <p>
                            Nenhum Registro encontrado
                        </p>
                    </template>

                    <template v-slot:cell(situacao)="{ item }">
                        <b-form-checkbox v-model="item.situacao" switch :disabled="!temPrivilegioEdicao()" :value="1"
                            :unchecked-value="0" />
                    </template>

                    <template v-slot:cell(action)="row">
                        <b-button v-b-tooltip.hover.bottom="'Editar'" :disabled="!temPrivilegioEdicao()" class="my-2"
                            size="sm" pill variant="primary" @click="editaPessoa(row.item)">
                            <b-icon icon="pencil-square" />
                        </b-button>
                    </template>

                    <template v-slot:cell(useradd)="row">
                        <b-button v-b-tooltip.hover.bottom="'Associar Usuário...'" :id="row.index + 'user-button'"
                            class="my-2" size="sm" pill variant="primary" @click="abrirFinderUsuario(row.item)">
                            <b-icon icon="people" />
                        </b-button>

                    </template>

                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="8" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage
                            }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select v-model="perPage" @change="() => this.load()" :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
            <PessoaForm v-if="cadastrarPessoa" @close="cancelar" :prefix="[prefix + title]" :id="currentPessoaId" />
            <LgFinderPageUsuario id="finderUsuarioPessoaList" @onselect="selecionarUsuario" :pessoa="pessoa"
                :isModal="true" :prefix="prefix + title + ' > '" v-if="mostrarUsuario" @close="fecharFinderUsuario">
            </LgFinderPageUsuario>
        </b-card-body>
    </b-card>

</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import PessoaForm from './PessoaForm.vue'
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import LgFinderPageUsuario from "@/components/Finders/LgFinderPageUsuario.vue"
import ConfiguracaoSistemaEnum from "@/core/utils/ConfiguracaoSistemaEnum"

export default {
    name: "PessoaList",

    components: {
        LgFormInput,
        LgFormConstSelect,
        PessoaForm,
        LgFinderPageUsuario
    },

    props: {
        precisaExistirUsuario: {
            type: Boolean,
            default: false,
        },
        id: String,
        onDblClickPessoa: Function,
        onDblClickUsuarioResponsavel: Function,
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Pessoa"
        }

    },

    data() {
        return {
            usarSIAPI: false,
            pessoa: null,
            mostrarUsuario: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            cadastrarPessoa: false,
            form: {
                nome: "",
                pessoa: null,
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: null },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
            currentPessoaId: null,
        };
    },
    mixins: [ListResourceMixin],
    async beforeMount() {
        this.$service = new ResourceService(`/api/pessoa`);
        var { data } = await new ResourceService("/api/configuracoes-sistema").get(ConfiguracaoSistemaEnum.UTILIZAR_SIAPI_CADASTRO_PESSOA.codConfiguracaoSistema);

        if (data.valorPropriedade == null || data.valorPropriedade == "" || data.valorPropriedade == '0') {
            this.usarSIAPI = false;
        }
        else {
            this.usarSIAPI = true;
        }

    },
    mounted() {
        this.load();
    },
    watch: {
        page() {
            this.load();
        },
    },
    computed: {
        tableFields() {
            var fields = [
                { key: "nome", label: "Nome", tdClass: "w-30" },
                { key: "usuarioNome", label: "Nome de Usuário", tdClass: "w-17" },
                { key: "rg", label: "RG", tdClass: "w-17" },
            ];

            if (this.usarSIAPI) {
                fields.push({ key: "siapi", label: "SIAPI", tdClass: "w-17" });

            }
            else {
                fields.push({ key: "cpf", label: "CPF", tdClass: "w-17" });

            }

            fields.push({ key: "useradd", label: "", tdClass: "w-1" });
            fields.push({ key: "action", label: " ", tdClass: "w-1" });
            fields.push({ key: "situacao", label: " ", tdClass: "w-1" });


            return fields;

        },
    },
    methods: {
        async selecionarUsuario(item) {
            try {

                await this.$service.put(`associar/${this.pessoa}/${item.id}`);
                this.fecharFinderUsuario();
                this.$notify({
                    type: "success",
                    message: "Usuário associado a Pessoa com sucesso",
                });
                this.load();

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }
        },
        fecharFinderUsuario() {
            this.mostrarUsuario = false;
            this.pessoa = null;

        },
        abrirFinderUsuario(pessoa) {
            this.pessoa = pessoa.id;
            this.mostrarUsuario = true;

        },

        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

        },
        async load() {
            this.filtro = {};


            if (this.form.nome != "") {
                this.filtro.nome = this.form.nome;
            }

            if (this.form.situacao != undefined) {
                this.filtro.situacao = this.form.situacao;
            }

            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });
        },
        async pessoaSelect(item) {

            if (this.precisaExistirUsuario && (!item.usuarioNome || item.usuarioNome == "")) {
                this.$notify({
                    type: "danger",
                    message: "Não é possível selecionar uma Pessoa sem usuário",
                });
                return;
            }
            this.$emit("onDblClickPessoa", item);
        },
        async abrirCadastrarPessoaModal() {
            this.cadastrarPessoa = true;
        },
        fecharCadastroPessoaModal() {
            this.cadastrarPessoa = false;
        },
        cancelar() {
            this.currentPessoaId = null;
            this.load();
            this.fecharCadastroPessoaModal();
        },
        async editaPessoa(pessoa) {

            if (this.temPrivilegioEdicao()) {
                this.currentPessoaId = pessoa.id;
                this.abrirCadastrarPessoaModal();
            }
        }
    },
};
</script>
